import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { FiGithub, FiLinkedin, FiArrowDown } from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-indigo-600/20 rounded-full blur-[120px] -z-10" />
      
      <div className="max-w-5xl mx-auto px-6 text-center z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="inline-block mb-4 px-4 py-1.5 rounded-full border border-indigo-500/30 bg-indigo-500/10 text-indigo-300 text-sm font-medium"
        >
          Full Stack Developer & AI Specialist
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-display text-5xl md:text-7xl font-bold leading-tight mb-6"
        >
          Building scalable <span className="text-gradient">SaaS</span> <br /> & Intelligent AI Agents.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed"
        >
          I'm <strong className="text-white">Dhaanu</strong>. A <strong className="text-white">Full Stack Developer</strong> with a unique background in customer success. I build end-to-end architectures and AI products that serve <span className="text-white">20K+ monthly active users</span> and handle <span className="text-white">200K+ monthly API requests</span>.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="experience"
            smooth={true}
            offset={-80}
            duration={500}
            className="px-8 py-3.5 bg-white text-slate-950 font-semibold rounded-full hover:bg-slate-200 transition-colors w-full sm:w-auto cursor-pointer"
          >
            Explore My Work
          </Link>
          <div className="flex items-center gap-4">
            <SocialButton icon={FiGithub} href="https://github.com/DhaanuI" />
            <SocialButton icon={FiLinkedin} href="https://www.linkedin.com/in/dhaanu/" />
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-slate-500"
      >
        <FiArrowDown size={24} />
      </motion.div>
    </section>
  );
};

const SocialButton = ({ icon: Icon, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="p-3.5 bg-slate-800 hover:bg-slate-700 text-white rounded-full transition-colors border border-slate-700"
  >
    <Icon size={20} />
  </a>
);

export default Hero;